export const VIEWS = {
    DEFAULT : 'default',
    MODAL : 'modal'
}
